export default __webpack_public_path__ + "static/media/scrabble-1920w.d67e72ce.avif";